<template lang="pug">
.no-use-container()
  .no-take
    .no-take-word
      .no-take-word-one 已有生效中的超级会员
  </template>
<script>
// import { UBT } from '@hb/tianqi/lib/ubt.h5';

export default {
  components: {
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
    };
  },
  destroyed() {
  },
  created() {
  },
  methods: {
  },
};
</script>
<style lang="less" scoped>
.no-use-container {
  position: fixed;
  bottom: 0;
  z-index: 222;
  width: 100%;

  .no-take {
    border-radius: 0.16rem 0.16rem 0 0;
    position: relative;
    z-index: 223;
    height: 1.0417rem;
    background: #fff;
    padding: 0.16rem 0.2rem 0.36rem 0.2rem;

    .no-take-word {
      background: linear-gradient(90deg, #eae9e9 0%, #c9cfd6 100%);
      border: 0.005rem solid #d3dae0;
      height: 0.52rem;
      border-radius: 0.12rem;
      padding-top: 0.15rem;

      .no-take-word-one {
        font-size: 0.16rem;
        font-weight: 500;
        line-height: 0.224rem;
        text-align: center;
        color: #373b3e;
      }

      .no-take-word-two {
        font-family: PingFang SC;
        font-size: 0.1rem;
        font-weight: 400;
        line-height: 0.14rem;
        text-align: center;
        color: #879099;
      }
    }
  }

  .shadow {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: #000;
    opacity: 0.7;
    z-index: 100;
  }
}
</style>
